var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.667V3C1 1.895 1.895 1 3 1H15C16.105 1 17 1.895 17 3V13.667C17 14.393 16.606 15.063 15.971 15.415L9.971 18.748C9.367 19.084 8.632 19.084 8.028 18.748L2.028 15.415C1.394 15.062 1 14.393 1 13.667Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.802 11.909L8.632 11.473C8.863 11.352 9.139 11.352 9.37 11.473L10.2 11.909C10.468 12.05 10.791 12.026 11.035 11.848L11.345 11.623C11.589 11.446 11.711 11.145 11.661 10.848L11.502 9.924C11.458 9.667 11.543 9.404 11.73 9.222L12.401 8.568C12.617 8.357 12.695 8.042 12.602 7.755L12.484 7.391C12.391 7.104 12.143 6.895 11.844 6.851L10.916 6.716C10.658 6.679 10.435 6.516 10.319 6.282L9.904 5.441C9.769 5.171 9.493 5 9.191 5H8.808C8.506 5 8.23 5.171 8.097 5.442L7.682 6.283C7.566 6.517 7.343 6.68 7.085 6.717L6.158 6.851C5.859 6.895 5.611 7.104 5.518 7.391L5.4 7.755C5.307 8.042 5.384 8.357 5.601 8.568L6.272 9.222C6.459 9.404 6.544 9.667 6.5 9.924L6.341 10.848C6.29 11.146 6.413 11.446 6.657 11.623L6.967 11.848C7.211 12.025 7.534 12.049 7.802 11.909V11.909Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldStar);
export default __webpack_public_path__ + "static/media/shield-star.87f3faa6352ed0c0e09f834227a55951.svg";
export { ForwardRef as ReactComponent };